import { quotesConstants } from './constants';

export const dashboardInitialState = {
  data: null,
  pending: false,
  error: false,
};

export const initialState = {
  data: [],
  pending: false,
  error: false,
  dashboard: dashboardInitialState,
};

const isCurrentRequest = (state, requestId) =>
  requestId === undefined || state.requestId === requestId;

const isCurrentDashboardRequest = (state, requestId) =>
  requestId === undefined || state.dashboard.requestId === requestId;

export function quotes(state = initialState, action) {
  switch (action.type) {
    case quotesConstants.GET_QUOTES_REQUEST: {
      const nextState = action.requestId === undefined
        ? state
        : { ...state, requestId: action.requestId };

      if (action.preserveData) {
        return {
          ...nextState,
          pending: true,
          error: false,
        };
      }

      return {
        ...initialState,
        dashboard: state.dashboard,
        ...(action.requestId === undefined ? {} : { requestId: action.requestId }),
        pending: true,
      };
    }
    case quotesConstants.GET_QUOTES_SUCCESS:
      if (!isCurrentRequest(state, action.requestId)) return state;
      return {
        ...state,
        data: action.data.quotes,
        meta: action.data.meta,
        pending: false,
        error: false,
      };
    case quotesConstants.UPDATE_QUOTES_COMMENTS:
      return {
        ...state,
        data: state.data.map(quote => {
          if (quote.id === action.quote) {
            return {
              ...quote,
              comments: action.folder.comments,
            };
          }
          return quote;
        }),
      };
    case quotesConstants.GET_QUOTES_FAILURE:
      if (!isCurrentRequest(state, action.requestId)) return state;
      return {
        ...state,
        pending: false,
        error: true,
      };
    case quotesConstants.GET_DASHBOARD_REQUEST:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          ...(action.requestId === undefined ? {} : { requestId: action.requestId }),
          data: null,
          pending: true,
          error: false,
        },
      };
    case quotesConstants.GET_DASHBOARD_SUCCESS:
      if (!isCurrentDashboardRequest(state, action.requestId)) return state;
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          data: action.data,
          pending: false,
          error: false,
        },
      };
    case quotesConstants.GET_DASHBOARD_FAILURE:
      if (!isCurrentDashboardRequest(state, action.requestId)) return state;
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          data: null,
          pending: false,
          error: true,
        },
      };
    default:
      return state;
  }
}
